import type { FaireProductEntity } from "../../entity_types/product";

export const p_gt3zdc3x8u: FaireProductEntity = {
  token: "p_gt3zdc3x8u",
  type: "product",
  name: "J4475   LIGHT WEIGHT CABLE KNITTED CARDIGAN",
  brandToken: "b_4bdmvim3s7",
  brandName: "MIOU MUSE",
  imageUrl:
    "https://cdn.faire.com/fastly/173f345df8f96f9e1437b2da545c8ed27f0db5d201fb6e0bacd4295f822dbfc9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/36192b56400c79e3a6ddd820d5a16bf57b3fb5480de31fee78508cd357a98916.jpeg",
    "https://cdn.faire.com/fastly/4bbf95bde68ac2ddcd0303c99b8e14fcba66406fa32e246e2b23b6dc4fbbaa41.jpeg",
    "https://cdn.faire.com/fastly/a56955983cf5aacd2e3a6320bce6eb942e3aa31fd763a9f804169897b4d393f0.jpeg",
    "https://cdn.faire.com/fastly/b0b70728ba7eccc0d78151280d71d4414004b3fdf1e7400ec421a2596b732384.jpeg",
    "https://cdn.faire.com/fastly/8fce412ff04f5f3ea063156f5e15513a5065724ac946b96ebce5696415acc736.jpeg",
    "https://cdn.faire.com/fastly/1af8576abcddd59123e726e248f924d8138721e0de82af7edebef901c24f7eb8.jpeg",
    "https://cdn.faire.com/fastly/9845de31666f90f25504a723fb9b2722a3edf97330a80abe2475acdc16c292fc.jpeg",
    "https://cdn.faire.com/fastly/0d6fa826b476f37b3b868470eabcd82f982609da7a7aa7974964de7b3c2b1d73.jpeg",
    "https://cdn.faire.com/fastly/2ae377559fc4e07342f75c4eef79cd7e3e1be10cb7064c01ae406c8351b8b601.jpeg",
    "https://cdn.faire.com/fastly/e76d012a6bbe0ffbda49ca2c424fbe065bcaada1e8ad80bb4cac79294ffd4ba5.jpeg",
    "https://cdn.faire.com/fastly/b29375e38b418814789e9e4109d5e3fc4fccb0240361434fbdc0cbb08c518ec7.jpeg",
    "https://cdn.faire.com/fastly/fa4e430dfb1fa584b55df66c90cfdce0e80d91e720c3c3f2c1dd9669a75f1a4d.jpeg",
    "https://cdn.faire.com/fastly/75b5c8760296edc6bdbc28c7c3bb4e32dfc7efdd126cc9c2881dc5a65bbd0654.jpeg",
    "https://cdn.faire.com/fastly/16a3c8c5bc637bc97802438bd6cabb4b81b06c45a05d522c6a3f5bda5ee6e07d.jpeg",
    "https://cdn.faire.com/fastly/2e0742dac5e5d5fc2aa6c3523b4c9af6d1ce555e3f84dc4fea13a507c086d5ed.jpeg",
    "https://cdn.faire.com/fastly/94c99b80f714a7075cb60231dddac740a110a4da122403cb9a7d90788a80e337.jpeg",
    "https://cdn.faire.com/fastly/8973b7b46d74618005bf434e0625eb4600525f7254c61a7b421cdb8133c86eee.jpeg",
    "https://cdn.faire.com/fastly/3e61c9522f69c65e9245a4bb2e1ca542842cf561dc065322592be8ecdc20cf3a.jpeg",
    "https://cdn.faire.com/fastly/45c322548366fad77e7e7c850a81ca12e9e4bc96eabaeb442a6e4e2dcacafe01.jpeg",
    "https://cdn.faire.com/fastly/e11bfadd60639a8307f6134535023f5e56b19d14e7858c44202835f5a5c9cc86.jpeg",
    "https://cdn.faire.com/fastly/4be7f4379c321b7abe87ebc09e272dd064b9b9c971be2d72fd02a2683e83ff24.jpeg",
    "https://cdn.faire.com/fastly/5d23dedaaf282268a3472e7576f5a11f3fdfb926b13ecb458262ee72981ff476.jpeg",
    "https://cdn.faire.com/fastly/3e24ed2dccec6f659191cb7c5509e3902a63d8a7d58c1e32c4045c918e739491.jpeg",
    "https://cdn.faire.com/fastly/8c48313080d1051c3f41b4ab424e6d035a90277943daab36682b5443a9799b3f.jpeg",
    "https://cdn.faire.com/fastly/e308027f346f921ead4e4ee9e4d4cbf104dc1f866beadd53253fd7b780a9c671.jpeg",
    "https://cdn.faire.com/fastly/d9a3645fd7eca2080b7840e1714fc2ea2e1830ab8ebf3f62237b1ba9a79f979f.jpeg",
    "https://cdn.faire.com/fastly/6b911efddb63872927224f75fc7222faac8823276950b37cffb6093c0bc9a8c6.jpeg",
    "https://cdn.faire.com/fastly/7ca32a0381e03e808b5a6febe45a9a7f2a28b9dfbca1be9cead5667119eed3b1.jpeg",
    "https://cdn.faire.com/fastly/7ee9d89b9658f6727b28fe17b1f951bc3c84d6a24e1d0e8b341309d28632f1b2.jpeg",
    "https://cdn.faire.com/fastly/b34ddaa433e9f38b0828910cbce81310f5ab27b86f07f9bcc00b40b4a1a67789.jpeg",
    "https://cdn.faire.com/fastly/cf978d47a657d121b6d2cbc9d22c461490b5769c8e2b3d416b263cc5a181d51a.jpeg",
    "https://cdn.faire.com/fastly/50bc2a368c5439d98125e8e6f2567f0738ee14f4cbc7f17dab3ca1f405e5f06f.jpeg",
    "https://cdn.faire.com/fastly/efd606e0f9020498c4293fdc0b13ee586709f955d109465ab2b24dfcb151c759.jpeg",
    "https://cdn.faire.com/fastly/0b2b773f6b5ba05db8aba3a9ed718c349a9d4f54f4d285146f01e1b69954739f.jpeg",
  ],
  priceDollars: 153,
  description:
    "Light Weight Cable Knitted Cardigan\n\n𝗦𝗶𝘇𝗲 & 𝗙𝗶𝘁\n• Model is wearing size S\n• Measurements taken from size S\n• Height - 5' 7 1/2\" / 175.3CM",
  tags: [],
  msrpDollars: 306,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:14:54.281Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
